//var text = ``;

////console.log(text);
var draft = {
	title: 'Perkara Abc doc',
	project_type: 'Non-Retainer',
	doc_type: 'Proposal',
	company: {
		name: 'PT Multijasa Perkasa'
	},
	client: {
		name: 'Wijayakarta Sumargono'
	},
	date_start: '10 Jun 2020',
	date_end: '10 Jul 2021',
	scope_desc: 'scope',
	amount: '120.000.000',
	amount_text: 'Seratus dua puluh juta rupiah'
}

var bhs = {
	header: 'header',
	intro: 'intro',
	services: [
		'Hukum Perdata dan Pidana;',
		'Hukum Perusahaan; ',
		'Hukum Kepailitan; ',
		'Hukum Pasar Modal; ',
		'Hukum Hak Kekayaan Intelektual (HKI)',
		'Hukum Perburuhan;',
		'Hukum Kesehatan; ',
		'Hukum Pertambangan;',
		'Hukum Keluarga-Perkawinan; ',
		'Hukum Properti; dan',
		'Hukum Perbankan.'
	],
	intro2: 'intro2',
	h1: 'h1',
	p1: 'p1',
	ol1: draft.scope_desc,
	h2: 'h2',
	p2: 'p2',
	h3: 'h3',
	p3: 'p3',
	ul3: ['ul31','ul32','ul33','ul34'],
	h4: 'h4',
	p4: 'p4',
	h5: 'h5',
	p5: 'p5'
};
var sign = 'sign';

export const docContent = [{
	alignment: 'justify',
	text: bhs.header
}, {
	alignment: 'justify',
	text: bhs.intro
}, {
	alignment: 'justify',
	ul: bhs.services
}, {
	alignment: 'justify',
	text: bhs.intro2
}, {
	alignment: 'justify',
	text: bhs.h1,
	style: 'header'
}, {
	alignment: 'justify',
	text: bhs.p1
}, {
	alignment: 'justify',
	text: bhs.ol1
}, {
	alignment: 'justify',
	text: bhs.h2,
	style: 'header'
}, {
	alignment: 'justify',
	text: bhs.p2
}, {
	alignment: 'justify',
	text: bhs.h3,
	style: 'header'
}, {
	alignment: 'justify',
	text: bhs.p3
}, {
	alignment: 'justify',
	ul: bhs.ul3,
	style: 'ul'
}, {
	alignment: 'justify',
	text: bhs.h4,
	style: 'header'
}, {
	alignment: 'justify',
	text: bhs.p4
}, {
	alignment: 'justify',
	text: bhs.h5,
	style: 'header'
}, {
	alignment: 'justify',
	text: bhs.p5
}, {
	alignment: 'center',
	text: sign
}];

export const docStyles = {
	header: {
		fontSize: 16,
		bold: true
	},
	bigger: {
		fontSize: 20,
		italics: true
	}
}

export const docDefaultStyle = {
	columnGap: 20
}